'use client'

import type { ReactNode, Ref } from 'react'
import Slider from 'react-slick'

import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'

export function Swipe({
  ref,
  children,
  adaptiveHeight = true,
}: {
  children?: ReactNode
  adaptiveHeight?: boolean
  ref?: Ref<Slider>
}) {
  return (
    <Slider
      adaptiveHeight={adaptiveHeight}
      arrows={false}
      dots={false}
      infinite={false}
      ref={ref}
      swipe={false}
    >
      {children}
    </Slider>
  )
}
